import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import dayjs from "dayjs";
import { InitService, UserService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import $enDigits from "@/mixins/enDigits";
import userService from "@/services/modules/userService";
import contactService from "@/services/modules/contactService";
import authService from "@/services/modules/authService";

const mobileInputComponent = () =>
  import(
    /* webpackChunkName: "count-down" */ "@/components/AccountPage/Kyc/PersonalContact/Mobile/index"
  );

export default {
  name: "personal-information",
  mixins: [$enDigits],
  data() {
    return {
      phoneNumber: "",
      countryIsoExist: false,
      phoneRules: [
        v => !!v || "Phone number is required",
        v => v.length >= 10 || "Phone number must be at least 10 digits"
      ],
      userTypes: [],
      model: {},
      countries: [],
      userFormFields: [],

      firstNameInput: "",
      nationalCodeInput: "",
      mobileInput: "",
      isNCHover: false,
      isNCFocus: false,
      birthDatePicker: "",
      lastNameInput: "",
      isRequesting: false,
      isModalOpen: false,
      requiredRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.identityInformation.personalInformation.validation.firstNameRequired"
          )
      ],
      lastNameRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.identityInformation.personalInformation.validation.lastNameRequired"
          ),
        v =>
          /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]+$/.test(
            v.replace(/\s/g, "")
          ) ||
          this.$t(
            "accountPage.identityInformation.personalInformation.validation.lastNamePersianRequired"
          )
      ],
      birthDayRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.identityInformation.personalInformation.validation.birthDayRequired"
          )
      ],
      internationalRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.identityInformation.personalInformation.validation.nationalCodeRequired"
          ),
        v =>
          /^\d{10}$/.test(v) ||
          this.$t(
            "accountPage.identityInformation.personalInformation.validation.nationalCodeValidation"
          )
      ]
    };
  },
  components: { datePicker: VuePersianDatetimePicker, mobileInputComponent },

  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      initData: types.init.getters.GET_INIT_DATA
    }),
    nCNameClass() {
      if (this.isNCFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isNCValid) {
          return "mobile_name_error";
        } else {
          if (this.nationalCodeInput) {
            return "mobile_name_fill";
          } else {
            if (this.isNCHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },
    firstName() {
      return this.userInfo?.first_name;
    },
    lastName() {
      return this.userInfo?.last_name;
    },
    activeButton() {
      const firstNameValidate = /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]+$/.test(
        this.firstNameInput.replace(/\s/g, "")
      );
      const lastNameValidate = /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]+$/.test(
        this.lastNameInput.replace(/\s/g, "")
      );
      if (
        this.firstNameInput.length &&
        this.lastNameInput.length &&
        this.nationalCodeInput.length &&
        this.birthDatePicker.length &&
        firstNameValidate &&
        lastNameValidate
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    this.getUserInfo();
    this.getInit();

    this.getUserTypes();
    this.getAllCountries();
  },
  methods: {
    dayjs,
    ...mapActions({
      setUserData: types.userInfo.actions.ACTION_USER_INFO,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO,
      setInit: types.init.actions.SET_INIT_DATA
    }),
    getAllCountries() {
      authService.getListOfCountries().then(res => {
        this.countries = res.data.data;
      });
    },
    regexRule(inputModel, regex, required, title) {
      if (required && !inputModel) {
        return this.$t(
          "accountPage.identityInformation.personalInformation.validation.firstNameRequired"
        );
      }
      if (!regex) {
        return true; // Skip validation if pattern is not loaded
      }
      const r = new RegExp(regex);
      console.log(r);
      return (
        r.test(inputModel) ||
        `${title} ${this.$t(
          "accountPage.identityInformation.personalInformation.validation.noValid"
        )}`
      );
    },
    getUserTypes() {
      userService.getUserTypeForKyc().then(res => {
        this.userTypes = res.data.data;
        this.userFormFields = res.data.data[0].fields;
        this.model.type_id = res.data.data[0]?.id;
        this.userFormFields.forEach(item => {
          this.countryIsoExist = item.name === "country_code";
        });
      });
    },
    changeCountry(country) {
      this.model.country_code = country.calling_code;
    },
    getFormOfKycType(id) {
      let result = this.userTypes.find(obj => obj.id === id);
      this.userFormFields = result.fields;
      this.userFormFields.forEach(item => {
        this.countryIsoExist = item.name === "country_code";
      });
    },

    getInit() {
      InitService.init().then(res => {
        this.setInit(res.data.data);
      });
    },
    verifyMobile(otp) {
      this.startRequest();
      contactService.verifyMobile(otp).then(() => {
        this.isModalOpen = false;
        this.updateInfo();
      });

      // const data = {
      //   otp: otp,
      //   mobile: this.mobileInput,
      //   national_code: this.nationalCodeInput,
      //   first_name: this.firstNameInput,
      //   last_name: this.lastNameInput,
      //   birth_date: this.birthDatePicker
      // };
      // this.startRequest();
      // userService
      //   .personalInformationUpdate(data)
      //   .then(() => {
      //     this.$router.push("/account/kycResult");
      //     this.isModalOpen = false;
      //   })
      //   .finally(() => {
      //     this.finishRequest();
      //   });
    },
    getMobileNumber(mobile) {
      this.model.mobile = mobile;
    },
    setNCHover(bool) {
      this.isNCHover = bool;
    },

    toggleNCFocus() {
      this.isNCFocus = !this.isNCFocus;
    },
    clearBirthDatePicker() {
      this.birthDatePicker = "";
    },
    dateMethod(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
    filteredPayload(obj) {
      return Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(obj).filter(([_, v]) => v !== null)
      );
    },
    updateInfo() {
      if (this.initData.kyc.is_active) {
        this.startRequest();
        let copyModel = {
          ...this.model,
          birth_date: Math.floor(
            new Date(this.model.birth_date).getTime() / 1000
          )
        };
        const filteredModel = this.filteredPayload(copyModel);
        userService
          .userKycVerification(filteredModel)
          .then(res => {
            if (res.data.data?.need_verified_mobile) {
              this.isModalOpen = true;
            } else {
              if (res.data.data.kyc_step === "FULL_VERIFIED") {
                this.$router.push({
                  path: "/account/kycResult"
                });
              } else {
                this.$router.push({
                  path: "/account/personal/autoKyc/typeSelection"
                });
              }
            }
          })
          .finally(() => {
            this.finishRequest();
          });
      }

      // if (this.initData.kyc.is_active) {
      //   this.startRequest();
      //   const data = {
      //     ...this.model,
      //     mobile: this.mobileInput,
      //   };
      //   UserService.shahkar(data)
      //     .then(res => {
      //       if (res.data.data?.is_mobile_verified) {
      //         const data = {
      //           mobile: this.mobileInput,
      //           national_code: this.nationalCodeInput,
      //           first_name: this.firstNameInput,
      //           last_name: this.lastNameInput,
      //           birth_date: this.birthDatePicker
      //         };
      //         userService
      //           .personalInformationUpdate(data)
      //           .then(() => {
      //             this.$router.push({
      //               path: "/account/kycResult"
      //             });
      //           })
      //           .finally(() => {
      //             this.finishRequest();
      //           });
      //       } else {
      //         this.isModalOpen = true;
      //       }
      //     })
      //     .catch(error => {
      //       this.finishRequest();
      //       this.$toast.error(error.data.message);
      //     });
      // } else {
      //   this.$toast.error(
      //     "accountPage.identityInformation.personalInformation.authUnavailable"
      //   );
      // }

      // this.updateAuthVerifyInfo();
      // this.updateUserInfo();

      // })
      // .finally(() => this.finishRequest());
      // UserService.updateInfo(data)
      //   .then(res => {
      //     this.$toast.success(res.data.message);
      //     this.updateAuthVerifyInfo();
      //     this.updateUserInfo();
      //     this.$router.push({
      //       path: "/panel/account/personal/autoKyc"
      //     });
      //   })
      //   .finally(() => this.finishRequest());
    },
    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
        if (this.userInfo?.first_name)
          this.firstNameInput = this.userInfo?.first_name;
        if (this.userInfo?.last_name)
          this.lastNameInput = this.userInfo?.last_name;
        if (this.userInfo?.national_code)
          this.nationalCodeInput = this.userInfo?.national_code;
        if (this.userInfo?.birth_date)
          this.birthDatePicker = this.dateMethod(this.userInfo?.birth_date);
      });
    },
    updateAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    updateUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
  },
  watch: {
    nationalCodeInput(number) {
      const value = this.$enDigits(number);
      this.nationalCodeInput = value;
    }
  }
};
